import { Box, IconButton } from '@mui/material'
import { FaRobot } from 'react-icons/fa'
import { IoClose } from 'react-icons/io5'
import { FormattedMessage } from 'react-intl'

import { Warning } from 'components/alert'
import {
    useAutoTranslateNotificationLastDismissed,
    useSetAutoTranslateNotificationLastDismissed,
} from 'stores/NotificationStore'

export const AutoTranslateNotification = () => {
    const setAutoTranslateNotificationLastDismissed = useSetAutoTranslateNotificationLastDismissed()
    const autoTranslateNotificationLastDismissed = useAutoTranslateNotificationLastDismissed()

    if (autoTranslateNotificationLastDismissed) return null

    return (
        <Warning>
            <Box sx={styles.container}>
                <FaRobot
                    style={{
                        height: '24px',
                        width: '24px',
                        marginTop: '-1px',
                    }}
                />
                <Box sx={styles.textContainer}>
                    <FormattedMessage
                        defaultMessage="Translation generated automatically."
                        description="Automatic French translation notice"
                    />
                    <br />
                    <FormattedMessage
                        defaultMessage="Errors may have been introduced."
                        description="Translation errors disclaimer"
                    />
                </Box>
                <IconButton
                    size="small"
                    onClick={() => setAutoTranslateNotificationLastDismissed(Date.now())}
                    sx={styles.closeButton}
                >
                    <IoClose />
                </IconButton>
            </Box>
        </Warning>
    )
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    textContainer: {
        flex: 1,
        margin: '0 8px',
        textAlign: 'left',
        marginLeft: 'var(--s0)',
    },
    closeButton: {
        color: 'rgba(0, 0, 0, 0.6)',
    },
}
